"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compactStyles = exports.baseStyles = void 0;
// NOTE: considering adding a specifc prop for grid row padding
const baseStyles = exports.baseStyles = {
  gap: {
    base: 4,
    tablet: 8
  },
  templateColumns: 'repeat(12, 1fr)'
};
const compactStyles = exports.compactStyles = {
  gap: 4
};